import { useEffect } from "react";
import { Box, Divider, Drawer, IconButton, Toolbar, useTheme } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Logo } from "../logo/Logo";
import { DrawerNavMenu } from "./DrawerNavMenu";
import { DrawerThemeToggle } from "./DrawerThemeToggle";
import { useDrawer } from "../../utils/useDrawer";

const MOBILE_DRAWER_WIDTH = 280;

// Temporary overlay drawer for mobile. Auto-closes on route change so
// the user lands on the next page without a stray drawer in the way.

export function DrawerMobile() {
  const theme = useTheme();
  const { isOpen, hide } = useDrawer();
  const location = useLocation();

  useEffect(() => {
    hide();
  }, [location.pathname, hide]);

  return (
    <Drawer
      variant="temporary"
      open={isOpen}
      onClose={hide}
      ModalProps={{ keepMounted: true }}
      sx={{
        display: { xs: "block", md: "none" },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: MOBILE_DRAWER_WIDTH,
        },
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
        }}
      >
        <Box component={RouterLink} to="/" sx={{ textDecoration: "none" }}>
          <Logo height={40} dark={theme.palette.mode === "dark"} />
        </Box>
        <IconButton onClick={hide} edge="end" aria-label="close drawer">
          <Close />
        </IconButton>
      </Toolbar>
      <Divider />
      <Box sx={{ flexGrow: 1, overflow: "auto", px: 1, py: 1 }}>
        <DrawerNavMenu />
      </Box>
      <Divider />
      <Box sx={{ p: 1 }}>
        <DrawerThemeToggle />
      </Box>
    </Drawer>
  );
}
